import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { FilterSearchParam } from '../../../../../../shared-components/elementis/types/FilterSearchParam';
import { ResultModule, useResultsDataContext } from '../../ResultsDataContext';

export function useSelectedModule() {
  const [searchParams, setSearchParams] = useSearchParams();
  const { modules } = useResultsDataContext();

  const selectedModuleId = searchParams.get(FilterSearchParam.Module);

  const selectedModule: ResultModule | null = useMemo(() => {
    if (selectedModuleId) {
      return modules.find(m => m.id === selectedModuleId) || null;
    }

    return null;
  }, [modules, selectedModuleId]);

  const setSelectedModule = useCallback(
    (module: ResultModule) => {
      setSearchParams(prev => {
        const newParams = new URLSearchParams(prev);
        newParams.set('module', module.id);
        newParams.delete(FilterSearchParam.Exercises);
        return newParams;
      });
    },
    [setSearchParams],
  );

  return [selectedModule, setSelectedModule] as const;
}
